import React from 'react';
import styled from 'styled-components';
import { theme } from '../styles/theme';
import { Section } from '../styles/commonStyles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faTwitter, faThreads } from '@fortawesome/free-brands-svg-icons';
import { TitleWithSubtitle, JapaneseTitle, EnglishTitle, SocialLinks, SocialLink, SocialIconWrapper } from '../styles';

const ProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 800px;
  margin: 0 auto;
  padding: ${theme.space.xl} ${theme.space.md};
  position: relative;
`;

const ProfileContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  
  @media (min-width: ${theme.breakpoints.tablet}) {
    flex-direction: row;
    align-items: flex-start;
    gap: ${theme.space.xl};
  }
`;

const ProfileImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: ${theme.space.lg};
  
  @media (min-width: ${theme.breakpoints.tablet}) {
    margin-bottom: 0;
    flex-shrink: 0;
    width: 200px;
  }
`;

const ProfileImage = styled.div`
  width: 200px;
  height: 200px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const ProfileInfo = styled.div`
  background-color: #f5f5f5;
  border-radius: ${theme.radii.lg};
  padding: ${theme.space.lg};
  width: 100%;
  box-shadow: ${theme.shadows.sm};
`;

const ProfileName = styled.h3`
  font-size: ${theme.fontSizes.xl};
  font-weight: ${theme.fontWeights.bold};
  margin-bottom: ${theme.space.md};
  border-bottom: 1px solid ${theme.colors.border};
  padding-bottom: ${theme.space.sm};
`;

const ProfileDescription = styled.p`
  font-size: ${theme.fontSizes.md};
  line-height: 1.8;
  margin-bottom: ${theme.space.md};
`;

const SpeechBubble = styled.div`
  position: relative;
  background: #fff;
  border-radius: 30px;
  padding: ${theme.space.md} ${theme.space.lg};
  margin: ${theme.space.md} auto;
  margin-top: ${theme.space['2xl']};
  margin-bottom: ${theme.space['md']};
  max-width: 300px;
  text-align: center;
  box-shadow: ${theme.shadows.sm};
  font-size: ${theme.fontSizes.lg};
  border: 2px solid #000;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -15px;
    left: 50%;
    width: 0;
    height: 0;
    border: 15px solid transparent;
    border-top-color: #fff;
    border-bottom: 0;
    margin-left: -15px;
    z-index: 1;
  }
  
  &:before {
    content: '';
    position: absolute;
    bottom: -18px;
    left: 50%;
    width: 0;
    height: 0;
    border: 17px solid transparent;
    border-top-color: #000;
    border-bottom: 0;
    margin-left: -17px;
    z-index: 0;
  }
  
  @media (max-width: ${theme.breakpoints.tablet}) {
    max-width: 300px;
    padding: ${theme.space.sm} ${theme.space.md};
    font-size: ${theme.fontSizes.md};
  }
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    max-width: 300px;
    margin-top: ${theme.space.xl};
    margin-bottom: ${theme.space.md};
    padding: ${theme.space.xs} ${theme.space.sm};
    font-size: ${theme.fontSizes.md};
  }
`;

const SocialTitle = styled.span`
  font-size: ${theme.fontSizes.sm};
  margin-top: ${theme.space.xs};
  
  @media (max-width: ${theme.breakpoints.tablet}) {
    font-size: ${theme.fontSizes.xs};
  }
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 11px;
    margin-top: 2px;
  }
`;

const Profile: React.FC = () => {
  return (
    <Section>
      <TitleWithSubtitle>
        <JapaneseTitle>プロフィール</JapaneseTitle>
        <EnglishTitle>PROFILE</EnglishTitle>
      </TitleWithSubtitle>
      
      <ProfileContainer>
        <ProfileContent>
          <ProfileImageWrapper>
            <ProfileImage>
              <img src="/images/arayottokun.svg" alt="アラヨットくん" />
            </ProfileImage>
          </ProfileImageWrapper>
          
          <ProfileInfo>
            <ProfileName>アラヨットくん（30）</ProfileName>
            <ProfileDescription>
              年に1回か2回くらい海外旅行に行っています。サッカーも好きです。ギリシャの航空会社の対応に腹が立ち、怒りに身を任せてブログを始めました。
              <br />
              2級世界遺産検定取得済。
            </ProfileDescription>            
          </ProfileInfo>
        </ProfileContent>
        
        <SpeechBubble>
          SNSもフォローしてね
        </SpeechBubble>
        
        <SocialLinks>
          <SocialLink href="https://www.instagram.com/arayotravel" target="_blank" rel="noopener noreferrer">
            <SocialIconWrapper>
              <FontAwesomeIcon icon={faInstagram} size="xl" />
            </SocialIconWrapper>
            <SocialTitle>アラヨットラベル</SocialTitle>
          </SocialLink>
          {/* <SocialLink href="https://twitter.com/" target="_blank" rel="noopener noreferrer">
            <SocialIconWrapper>
              <FontAwesomeIcon icon={faTwitter} size="xl" />
            </SocialIconWrapper>
            <SocialTitle>アラヨックス</SocialTitle>
          </SocialLink>
          <SocialLink href="https://www.threads.net/" target="_blank" rel="noopener noreferrer">
            <SocialIconWrapper>
              <FontAwesomeIcon icon={faThreads} size="xl" />
            </SocialIconWrapper>
            <SocialTitle>アラヨッド</SocialTitle>
          </SocialLink> */}
        </SocialLinks>
      </ProfileContainer>
    </Section>
  );
};

export default Profile; 
